import { useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useMediaQuery, useTheme } from '@material-ui/core'
import useStyles from './Content4.styled'

export const useContent4 = props => {
	const { metaData } = props
	const sectionId = useSectionId()
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const classes = useStyles(props)

	const columnsNumber = Math.min(metaData.columns?.toNumber(), _.size(items))
	let maxWidth

	switch (columnsNumber) {
		case 3:
			maxWidth = 'md'
			break
		case 2:
			maxWidth = 'sm'
			break
		case 1:
			maxWidth = 'xs'
			break
		default:
			break
	}

	return [
		{
			classes,
			columnsNumber,
			items,
			maxWidth,
			verticalAlignment: metaData.verticalAlignment?.metaValue,
			alignment: isMobile ? metaData.mobileAlignment?.contentAlignment() : 'center',

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,
		},
		{
			handleTextClick,
			handleTextChange,
		},
	]
}
